import { render, staticRenderFns } from "./NoProducts.vue?vue&type=template&id=7da831e1&"
import script from "./NoProducts.vue?vue&type=script&lang=js&"
export * from "./NoProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoProducts.vue"
export default component.exports